import { inputRules } from 'utils/rules';

export enum SectionId {
  PRODUCT_API_ENABLED = 'productApiEnabledSection',
  PREORDER_PERIOD = 'preorderPeriodSection',
  REGION_AND_LOCALE_SETS = 'regionAndLocaleSetsSection',
}

export const fieldNameToSectionId: Record<keyof typeof inputRules, SectionId> =
  {
    preorderPeriod: SectionId.PREORDER_PERIOD,
    regionAndLocaleSets: SectionId.REGION_AND_LOCALE_SETS,
  };
